import { render, staticRenderFns } from "./replace-ingredient.vue?vue&type=template&id=3a51fa3d&"
import script from "./replace-ingredient.vue?vue&type=script&lang=js&"
export * from "./replace-ingredient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports